<template>
  <div class="part-item projectTeam">
    <div class="team-wrap">
      <div class="title">
        <p class="title-text">团队主要成员</p>

      </div>
      <div class="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th>姓名</th>
              <th>出生年月</th>
              <th>所在单位</th>
              <th>职称</th>
              <th>职务</th>
              <th>手机号</th>
              <th>承担任务</th>

            </tr>
            <tr
              class="item"
              v-for="(item, index) in mainData"
              :key="index"
            >
              <td class="person"><i
                  v-if="item.is_master"
                  class="person_symbol"
                >负责人</i>{{item.userprofile_id?item.userprofile.name : item.name}}</td>
              <td>{{item.birth?item.birth:'-'}}</td>
              <td>{{item.org_name?item.org_name:'-'}}</td>
              <td>{{item.rank?item.rank:'-'}}</td>
              <td>{{item.duty?item.duty:'-'}}</td>
              <td>{{formatPhone(item.userprofile_id?(item.userprofile.mobile?item.userprofile.mobile:'') : item.phone)}}</td>
              <td>{{item.task?item.task : '-'}}</td>

            </tr>
          </tbody>
          <tr
            class="noitems"
            v-if="!mainData.length"
          >
            <td colspan="7">没有数据</td>
          </tr>
        </table>

      </div>
    </div>
    <div class="team-wrap">
      <div class="title">
        <p class="title-text">团队其他成员</p>

      </div>
      <div class="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th>姓名</th>
              <th>出生年月</th>
              <th>所在单位</th>
              <th>职称</th>
              <th>职务</th>
              <th>手机号</th>
              <th>承担任务</th>
            </tr>
            <tr
              class="item"
              v-for="(item, index) in otherData"
              :key="index"
            >
              <td>{{item.userprofile_id?item.userprofile.name : item.name}}</td>
              <td>{{item.birth?item.birth:'-'}}</td>
              <td>{{item.org_name?item.org_name:'-'}}</td>
              <td>{{item.rank?item.rank:'-'}}</td>
              <td>{{item.duty?item.duty:'-'}}</td>
              <td>{{formatPhone(item.userprofile_id?(item.userprofile.mobile?item.userprofile.mobile:'') : item.phone)}}</td>
              <td>{{item.task?item.task : '-'}}</td>

            </tr>
          </tbody>
          <tr
            class="noitems"
            v-if="!otherData.length"
          >
            <td colspan="7">没有数据</td>
          </tr>
        </table>

      </div>
      <p class="part-tip">团队总人数：
        <span class="teamPeoTotal">{{mainData.length+otherData.length}}</span>人
      <div class="clearfix"></div>
      <p class="tips">注：必要的技术支持人员可作为团队主要成员；“承担任务”中除填写任务分工内容外，请说明属于在线教学服务人员还是技术支持人员。</p>
      <div class="clearfix"></div>
      <div class="title">
        <p class="title-text">团队主要成员教学情况（限500字以内）</p>
      </div>
      <div class="clearfix"></div>
      <p class="tips">（近5年来承担该实验教学任务情况，以及负责人开展教学研究、学术研究、获得教学奖励的情况）</p>
      <div class="clearfix"></div>
      <div
        class="part-content"
        v-if="!formInfo.main_member_tech"
      >暂无内容，请进行维护</div>
      <div
        class="part-content"
        v-if="formInfo.main_member_tech"
        v-html="formInfo.main_member_tech"
      ></div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ExperimentalTeam',
  data() {
    return {
      mainData: [],
      otherData: [],
      is_main: 0,
      teamAllData: [],
      master_id: 0,
      formInfo: {
        main_member_tech: ''
      }

    }
  },
  computed: {

  },
  props: ['expId'],
  methods: {
    formatPhone(phone) {
      if (!phone) {
        return '-'
      }
      let res = ''
      for (let i = 0; i < phone.length; i++) {
        if (i >= 3 && i <= 6 && !this.showPhone) {
          res += '*'
        } else {
          res += phone[i]
        }
      }
      return res
    },
    // 获取主要成员
    async getUseMember() {
      await this.$http.get('/allowany/experimentmember/', {
        params: {
          page: 1,
          size: 100,
          experiment_id: this.expId
        }
      }).then((data) => {
        this.mainData = []
        this.otherData = []
        this.teamAllData = data.results
        data.results.forEach(element => {
          if (element.is_main) {
            this.mainData.push(element)
          } else {
            this.otherData.push(element)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo.main_member_tech = data.main_member_tech
        this.master_id = data.master_id
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getUseMember()
    await this.getInfo()
  }
}
</script>
<style scoped src="../../assets/css/table.css"></style>
<style lang="less" scoped>
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}

.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}

.part-content {
  border: 1px solid #f0f0f0;
  padding: 20px;
  color: #666666;
  min-height: 110px;
  overflow: hidden;
  word-break: break-all;
}
.part-tip {
  margin-bottom: 10px;
}
</style>
